export const WINDOW_SIZE = {
    HORIZONTAL: {
        WIDTH: 1920,
        HEIGHT: 1080,
    },
    VERTICAL: {
        WIDTH: 1080,
        HEIGHT: 1920,
    },
};
